// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"0d54bb45","977":"7a7b0c82"}[chunkId] + ".chunk.js";
};